"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'onboarding.records.title': 'I Tuoi Record di Onboarding',
    'onboarding.records.empty.title': 'Nessun Record di Onboarding Ancora',
    'onboarding.records.empty.description': 'Inizia il tuo primo processo di onboarding per vedere i record qui.',
};
